import React from 'react';
import PropTypes from 'prop-types';

/**
 * This component relies on Segment (analytics.js) to trigger a page view on route changes.
 * It should be placed within a <BrowserRouter> outside of a <Switch> in the main App router
 * so that it will render on every route change.
 */
export class TrackPageViewComponent extends React.Component {
  componentDidMount() {
    const { referrer } = document;
    if (window && window.zola) {
      window.zola.referrer = referrer;
    }
    this.trackPageView(referrer);
  }

  componentDidUpdate({ location: prevLocation }) {
    const {
      location: { pathname, search },
    } = this.props;
    const isDifferentPathname = pathname !== prevLocation.pathname;
    const isDifferentSearch = search !== prevLocation.search;

    const protocol = window && window.location && window.location.protocol;
    const hostname = window && window.location && window.location.hostname;
    const referrer =
      prevLocation && prevLocation.pathname
        ? `${protocol}//${hostname + prevLocation.pathname + prevLocation.search}`
        : document.referrer;
    // Adds referrer on a global object to avoid the hassle of getting past and passing referrer to every component that calls an event.
    if (window && window.zola) {
      window.zola.referrer = referrer;
    }

    if (isDifferentPathname || isDifferentSearch) {
      this.trackPageView(referrer);
    }
  }

  trackPageView(referrer) {
    const {
      location: { pathname, search },
    } = this.props;
    if (window.analytics) {
      window.analytics.page({
        path: pathname,
        search,
        referrer,
        url: window.location.href,
        title: document && document.title,
      });
    }
  }

  render() {
    return null;
  }
}

TrackPageViewComponent.propTypes = {
  /**
   * should be provided by wrapping this component with 'withRouter'
   */
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

export default TrackPageViewComponent;
